module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"label":"AI가 추천하는 사이즈를 확인해 보세요"}}')
  delete Component.options._Ctor
}
